var _circle, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMedicalDiscounts = function SvgMedicalDiscounts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "var(--color-circle)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.508 16.826-4.862-5.22C24.462 9.218 23.45 7.5 22.144 7.5c-1.435 0-2.518 2.073-2.534 4.83l-4.745 2.299a2.765 2.765 0 0 0-1.378 1.609l-3.363 10.58a2.633 2.633 0 0 0 .199 2.061 2.797 2.797 0 0 0 1.646 1.33l4.383 1.332c.53.606 1.308.956 2.13.959h9.014c.746 0 1.462-.288 1.99-.797.528-.51.826-1.2.826-1.92V18.727a2.632 2.632 0 0 0-.804-1.9Zm-7.365-8.239c.443 0 1.039.884 1.29 2.352a2.353 2.353 0 0 0-1.844.433l-.832.403c.131-1.964.865-3.188 1.386-3.188Zm-9.836 20.584a1.678 1.678 0 0 1-.987-.797 1.578 1.578 0 0 1-.12-1.237l3.365-10.582c.131-.412.425-.756.817-.96l4.07-1.972-2.962 3.182c-.53.509-.827 1.2-.825 1.922v11.055c.003.142.018.284.044.424l-3.402-1.034Zm16.879.611c0 .433-.179.847-.496 1.153a1.725 1.725 0 0 1-1.194.478h-9.014c-.448 0-.878-.173-1.195-.478a1.605 1.605 0 0 1-.495-1.153V18.727c0-.443.187-.866.515-1.175l4.953-5.32c.205-.17.47-.26.74-.249.19-.003.377.04.546.123.003.094.006.188.006.285a7.241 7.241 0 0 1-.47 2.703l-.01.023c-.028-.002-.055-.008-.083-.008a1.152 1.152 0 0 0-.858.372 1.067 1.067 0 0 0 .233 1.636c.276.173.615.223.93.135.317-.087.578-.303.716-.59s.14-.618.006-.908c.04-.084.078-.17.115-.264a7.54 7.54 0 0 0 .513-2.261l4.047 4.345c.318.305.496.72.495 1.153v11.055Z",
    fill: "url(#MedicalDiscounts_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.33 20.703a.574.574 0 0 0-.796 0l-7.324 7.065a.535.535 0 0 0-.167.385c0 .144.059.283.165.386a.575.575 0 0 0 .8-.003l7.323-7.065a.534.534 0 0 0 .165-.384.534.534 0 0 0-.165-.384Z",
    fill: "url(#MedicalDiscounts_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.735 24.348c.598 0 1.171-.23 1.594-.637.422-.408.66-.96.66-1.537 0-.576-.238-1.13-.66-1.537A2.297 2.297 0 0 0 20.735 20c-.597 0-1.17.23-1.593.637-.423.408-.66.96-.66 1.537 0 .576.238 1.129.66 1.537.423.407.996.636 1.593.637Zm0-3.26c.3 0 .586.114.797.317.211.204.33.48.33.769 0 .288-.119.565-.33.769a1.148 1.148 0 0 1-.797.318c-.298 0-.585-.115-.796-.318a1.068 1.068 0 0 1-.33-.769c0-.288.119-.564.33-.768.211-.204.498-.319.796-.319Z",
    fill: "url(#MedicalDiscounts_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.806 24.891c-.598 0-1.171.23-1.594.637-.422.408-.66.96-.66 1.537s.238 1.13.66 1.537c.423.408.996.637 1.594.637.597 0 1.17-.229 1.593-.637.423-.407.66-.96.66-1.537 0-.576-.238-1.129-.66-1.536a2.299 2.299 0 0 0-1.593-.638Zm0 3.261c-.3 0-.586-.114-.797-.318a1.068 1.068 0 0 1-.33-.769c0-.288.119-.565.33-.768.211-.204.498-.319.797-.319.298 0 .585.115.796.319.212.203.33.48.33.768 0 .288-.119.565-.33.768a1.149 1.149 0 0 1-.796.32Z",
    fill: "url(#MedicalDiscounts_svg__d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MedicalDiscounts_svg__a",
    x1: 10,
    y1: 20,
    x2: 30.313,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MedicalDiscounts_svg__b",
    x1: 19.043,
    y1: 24.621,
    x2: 27.496,
    y2: 24.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MedicalDiscounts_svg__c",
    x1: 18.482,
    y1: 22.174,
    x2: 22.989,
    y2: 22.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MedicalDiscounts_svg__d",
    x1: 23.552,
    y1: 27.065,
    x2: 28.059,
    y2: 27.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })))));
};

export default SvgMedicalDiscounts;